<template>
  <div>
    <b-btn
      class="dashboard-export"
      variant="outline-primary"
      v-has-perms="summaryExcelRolePerm"
      :title="'Download data in Excel' | translate"
      @click="getSummaryDocument()"
    >
      <i class="fas fa-file-excel"></i>
    </b-btn>
    <div class="sidebar-filters">
      <organization-list-filter
        @edit="editComponentFilters($event, 'filter__organization__in')"
        @clean="cleanComponentFilters(['filter__organization__in'])"
        only-active
      />
    </div>
    <thux-table
      :instance="instance"
      :instance-name="instanceName"
      :order-by-dict="orderByDict"
      :goBack="goBack"
      :list="list"
      :fieldName="fieldName"
      :fields="fields"
      :fields-column="fieldsColumn"
      :select-all="selectAll"
      :selected-list="selectedList"
      :get-local-selected-all="getLocalSelectedAll"
      :local-selected-list="localSelectedList"
      @check-all="checkAll"
      @check-none="checkNone"
      @set-selected-row="setSelectedRow"
      :show-checks="showChecks"
      :showEditButton="showEditButton"
      @change-status="changeInstanceStatus"
      @sort-changed="orderTable"
      @remove-order-by="removeOrderFromTable"
    >
      <template slot="status_name" slot-scope="row">
        <span :class="`fw-600 tag tag-${DOCUMENT_UPLOADDOCUMENT_STATUS_COLORS[row.item.status]}`">
          {{row.item.status_name}}
        </span>
      </template>
      <template slot="organization__name" slot-scope="row">
        <span> {{ row.item.organization_typology_name ? `${row.item.organization_name} (${row.item.organization_typology_name})`: row.item.organization_name }}</span>
      </template>
      <template slot="date_start" slot-scope="row">
        {{ row.item.date_start | date}}
      </template>
      <template slot="date_end" slot-scope="row">
        <span :class="row.item.is_document_expired ? 'text-red' : ''">
          {{ row.item.date_end | date}}
        </span>
      </template>
      <template slot="other-buttons-actions-bottom" slot-scope="row">
        <b-btn v-if="row.item.attachment"
          v-has-perms="['document_uploaddocument_download_attachment']"
          variant="outline-primary"
          :title="'download' | translate"
          @click="downloadDocument(row.item)"
        >
          <i class="fas fa-download"></i>
        </b-btn>
        <b-btn
          v-has-perms="['document_uploaddocument_list']"
          variant="outline-primary"
          size="sm"
          :title="`${$t('Worker documents')} ${$t(instanceName)}`"
          @click="goToOrganizationDocuments(row)"
        >
          <i
            :title="`${$t('Worker documents')} ${$t(instanceName)}`"
            class="far fa-file-alt"
          />
        </b-btn>
      </template>
    </thux-table>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as ELIGIBILITY_TYPES } from './store'

import ThuxTableMixin from '../../../components/thux-table/ThuxTableMixin'
import ThuxTableChecksMixin from '../../../components/thux-table/thux-table-checks/ThuxTableChecksMixin'
import CommonFiltersMixin from '@/pages/common-filters/CommonFiltersMixin'

import { ROUTES as CUSTOMER_ORG_ROUTES } from '../../organization/organization/organization/customer-organization/router'
import { ROUTES as LEAD_ORG_ROUTES } from '../../organization/organization/organization/lead-organization/router'
import { ROUTES as SUPPLIER_ORG_ROUTES } from '../../organization/organization/organization/supplier-organization/router'

import { DOCUMENT_UPLOADDOCUMENT_STATUS_COLORS, ORGANIZATION_CUSTOMER_CODE, ORGANIZATION_SUPPLIER_CODE, ORGANIZATION_CUSTOMER_LEAD_CODE } from '@/const'

export default {
  name: 'EligibilityTable',
  mixins: [ThuxTableMixin, ThuxTableChecksMixin, CommonFiltersMixin],
  data () {
    return {
      DOCUMENT_UPLOADDOCUMENT_STATUS_COLORS,
      fields: [
        {
          key: 'status_name',
          label: this.$t('Status'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          custom: true
        },
        {
          key: 'organization__name',
          label: this.$t('Organization'),
          thClass: 'text-nowrap',
          tdClass: 'text-wrap',
          sortable: true,
          value: 'organization_name',
          custom: true
        },
        {
          key: 'worker__last_name',
          label: this.$t('Worker'),
          thClass: 'text-nowrap',
          tdClass: 'text-wrap',
          sortable: true,
          value: 'worker_full_name'
        },
        {
          key: 'date_start',
          label: this.$t('Validity start'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          custom: true
        },
        {
          key: 'date_end',
          label: this.$t('Validity end'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          custom: true
        },
        {
          key: 'action',
          label: this.$t('Actions'),
          tdClass: 'text-right text-nowrap',
          thClass: 'text-right text-nowrap'
        }
      ],
      fieldsColumn: [],
      fieldName: 'id',
      showDocumentHistoryModal: false,
      showPopoverDocStatusModal: false,
      summaryExcelRolePerm: ['document_uploaddocument_deadline_export']
    }
  },
  computed: {
    ...mapGetters({
      selectAll: ELIGIBILITY_TYPES.GENERIC.dashboard.eligibility.LIST.GETTERS.selectAll,
      selectedList: ELIGIBILITY_TYPES.GENERIC.dashboard.eligibility.LIST.GETTERS.selectedList
    }),
    showChecks () {
      return true
    },
    showDetailButton () {
      return false
    },
    showEditButton () {
      return false
    }
  },
  methods: {
    ...mapMutations({
      setList: ELIGIBILITY_TYPES.GENERIC.dashboard.eligibility.LIST.MUTATIONS.setList,
      setSelectedList:
        ELIGIBILITY_TYPES.GENERIC.dashboard.eligibility.LIST.MUTATIONS.setSelectedList,
      setSelectAll: ELIGIBILITY_TYPES.GENERIC.dashboard.eligibility.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...ELIGIBILITY_TYPES.GENERIC.dashboard.eligibility.LIST.ACTIONS,
      partialUpdate: ELIGIBILITY_TYPES.GENERIC.dashboard.eligibility.DETAIL.ACTIONS.partialUpdate
    }),
    showPopoverDocumentStatus (uploadDocument) {
      this.$set(this, 'instance', uploadDocument)
      this.$set(this, 'showPopoverDocStatusModal', true)
    },
    changeUploadDocumentStatus (evt) {
      const formData = { id: this.instance.id, ...evt }
      this.partialUpdate(formData).then(
        () => {
          this.$set(this, 'instance', {})
          this.$set(this, 'showPopoverDocStatusModal', false)
        }
      )
    },
    resetInstance () {
      this.$set(this, 'instance', {})
      this.$set(this, 'showPopoverDocStatusModal', false)
    },
    goToOrganizationDocuments (data) {
      const params = { orgId: data.item.organization, orgType: data.item.default_org_type_code, cntId: data.item.worker }
      switch (data.item.default_org_type_code) {
        case ORGANIZATION_CUSTOMER_CODE:
          return this.$router.push({ name: CUSTOMER_ORG_ROUTES.CUSTOMER_ORGANIZATION_CONTACT_DOCUMENTS, params })
        case ORGANIZATION_SUPPLIER_CODE:
          return this.$router.push({ name: SUPPLIER_ORG_ROUTES.SUPPLIER_ORGANIZATION_CONTACT_DOCUMENTS, params })
        case ORGANIZATION_CUSTOMER_LEAD_CODE:
          return this.$router.push({ name: LEAD_ORG_ROUTES.LEAD_ORGANIZATION_CONTACT_DOCUMENT_LIST, params })
      }
    },
    downloadDocument (item) {
      const fileName = `${item.document_name}.${item.attachment_simple_filename.split('.').pop()}`
      this.download({ id: item.id, action: 'download-attachment', simpleFileName: fileName })
    },
    getSummaryDocument () {
      const fileName = `${this.$t('Eligibility Export')}.xlsx`
      const columns = this.fields.filter(
        (field) => field.key !== 'action'
      ).map(
        (field) => ({ key: field.key, value: field.value, label: field.label })
      )
      this.downloadSummary({ simpleFileName: fileName, columns })
    }
  }
}
</script>
